import { useMemo } from 'react';

import { useGetCurrentUser } from 'api/users';
import useAuth from 'hooks/useAuth';
import useTenantSelection from 'hooks/useTenantSelection';
import { normalizeUserDatePreferences } from 'utils/dateFormatter';

/** Returns normalized current-user display preferences with shared fallback values. */
export default function useUserPreferences() {
  const { user } = useAuth();
  const { tenantId } = useTenantSelection();
  const { currentUser, currentUserLoading, currentUserError } = useGetCurrentUser(tenantId, user?.id);
  const userPreferences = useMemo(() => normalizeUserDatePreferences(currentUser?.preferences), [currentUser?.preferences]);

  return {
    userPreferences,
    userPreferencesLoading: currentUserLoading,
    // False while the current-user record is absent (first load, or refetching after a tenant switch sweeps
    // the cache); userPreferences then holds the defaults, not the user's saved values.
    userPreferencesLoaded: currentUser != null,
    // The record could not be loaded, so the defaults are all there will be.
    userPreferencesFailed: currentUser == null && !currentUserLoading && currentUserError != null
  };
}
